import { render, staticRenderFns } from "./SdsSection3MaterialForm.vue?vue&type=template&id=404d6a1c&scoped=true"
import script from "./SdsSection3MaterialForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection3MaterialForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsSection3MaterialForm.vue?vue&type=style&index=0&id=404d6a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d6a1c",
  null
  
)

export default component.exports